import { LitElement, css, type CSSResultGroup } from 'lit';

/**
 * Shared base class for all MuseIQ Lit components.
 * Provides common reset styles and inherits CSS custom properties from :root.
 */
export class BaseElement extends LitElement {
    static styles: CSSResultGroup = css`
        :host {
            box-sizing: border-box;
        }

        :host *,
        :host *::before,
        :host *::after {
            box-sizing: inherit;
        }

        :host([hidden]) {
            display: none !important;
        }

        /* Reset for buttons inside components */
        button {
            font-family: inherit;
            font-size: inherit;
            border: none;
            background: none;
            color: inherit;
            cursor: pointer;
            padding: 0;
            margin: 0;
        }
    `;
}
